import { gql } from '@apollo/client';
import client from '../apollo-client';
import { UpdateUserPreferenceInput, UserPreferenceEntry } from '../interfaces/UserPreference';

const FIELDS = `
  key
  value
  isDefault
`;

/** Preferințele utilizatorului autentificat (operații „self" — serverul folosește id-ul din token). */
export class UserPreferenceService {
  async getMyPreferences(): Promise<UserPreferenceEntry[]> {
    const res = await client.query({
      fetchPolicy: 'network-only',
      query: gql`
        query MyPreferences {
          myPreferences {
            ${FIELDS}
          }
        }
      `,
    });
    return res.data.myPreferences;
  }

  async updateMyPreferences(inputs: UpdateUserPreferenceInput[]): Promise<UserPreferenceEntry[]> {
    const res = await client.mutate({
      variables: { input: inputs },
      mutation: gql`
        mutation UpdateMyPreferences($input: [UpdateUserPreferenceInput!]!) {
          updateMyPreferences(input: $input) {
            ${FIELDS}
          }
        }
      `,
    });
    return res.data.updateMyPreferences;
  }
}
